// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../../assets/styles/fonts/SFProDisplay-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../../../assets/styles/fonts/SFProDisplay-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../../../assets/styles/fonts/SFProDisplay-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../../../assets/styles/fonts/SFProDisplay-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SF Pro Display";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("SF Pro Display Semibold"), local("SFProDisplay-Semibold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 600;
  font-style: normal;
}
:root {
  --appSidebarWidth: 400px;
  xPathesWrapperWidth: 400px;
}

.XPathBlock_site-form-item-icon__7aRnV {
  color: #00A899;
}

.XPathBlock_ant-tabs-content__u9wAw, .XPathBlock_ant-tabs-tabpane__h5jM2 {
  height: 100% !important;
}

.XPathBlock_ant-col__uQYYe.XPathBlock_ant-form-item-control__FpE8Z.XPathBlock_css-dev-only-do-not-override-14wewjn__G0Qh3 label {
  display: inline !important;
}

.XPathBlock_ant-form-item-control-input-content__KFMph {
  display: flex;
  align-items: center !important;
  gap: 8px;
}

.XPathBlock_site-tree-search-value__iPh3f {
  background: #d3fd1a;
}

.XPathBlock_ant-tree__ubqlb .XPathBlock_ant-tree-treenode__xQZRQ {
  align-items: center !important;
}

textarea {
  overflow-y: scroll !important;
}

textarea::-webkit-scrollbar {
  width: 4px !important;
}

textarea::-webkit-scrollbar-thumb {
  background-color: #04867a !important;
  border-radius: 50px !important;
}

textarea::-webkit-scrollbar-track {
  background: #e2e4e7 !important;
}

.XPathBlock_ant-tree-switcher__1557e.XPathBlock_ant-tree-switcher_close__Gq\\+La,
.XPathBlock_ant-tree-switcher__1557e.XPathBlock_ant-tree-switcher_open__hpHdJ {
  line-height: 46px !important;
}

div[class*=TableAllProjects] .XPathBlock_ant-table-wrapper__WwCvq {
  padding: 24px !important;
  background: #fff !important;
}

.XPathBlock_app-sidebar__Pq3\\+5 {
  width: 50%;
}

.XPathBlock_app-sidebar__Pq3\\+5 .XPathBlock_app-sidebar-content__x0sK\\+ {
  width: 100%;
}

#XPathBlock_CDARedactorWrapper__t5bik {
  width: 100%;
  max-width: 100%;
}

.XPathBlock_ant-tree-treenode__xQZRQ {
  min-width: 400px !important;
  max-width: 600px !important;
}

.XPathBlock_fullScreen__oTV8E {
  position: fixed !important;
  width: 100vw !important;
  height: 100vh !important;
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  z-index: 9 !important;
  background: #F0F2F5 !important;
}
.XPathBlock_fullScreen__oTV8E .XPathBlock_app-container__bjqQl {
  min-height: 90vh;
  padding: 1em 1em;
  display: flex;
  flex-direction: row;
  height: 90vh;
}
.XPathBlock_fullScreen__oTV8E .XPathBlock_app-sidebar__Pq3\\+5 {
  flex-grow: 0;
  flex-shrink: 0;
  min-width: 400px;
  max-width: calc(100vw - var(--appSidebarWidth)) !important;
  display: flex;
  flex-direction: row;
  z-index: 2;
}
.XPathBlock_fullScreen__oTV8E .XPathBlock_app-frame__4ruN3 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 90vh;
  max-height: 90vh;
  width: calc(100vw - var(--xPathesWrapperWidth) - 200px) !important;
  min-width: 400px;
  border-radius: 0 10px 10px 0;
  z-index: 1;
}
.XPathBlock_fullScreen__oTV8E .XPathBlock_app-sidebar__Pq3\\+5 .XPathBlock_app-sidebar-content__x0sK\\+ {
  flex: 1 1;
}
.XPathBlock_fullScreen__oTV8E .XPathBlock_app-sidebar-resizer__xxmqG {
  position: relative;
  height: 84vh;
  width: 3px;
  top: 4vh;
  border-radius: 10px;
  background: rgba(193, 195, 197, 0.7058823529);
  flex-grow: 0;
  flex-shrink: 0;
  justify-self: flex-end;
  cursor: col-resize;
  resize: horizontal;
}
.XPathBlock_fullScreen__oTV8E .XPathBlock_ant-tree-treenode__xQZRQ.XPathBlock_ant-tree-treenode-switcher-open__HGOvv.XPathBlock_ant-tree-treenode-draggable__PKauI {
  width: 100% !important;
  max-width: 100% !important;
  position: relative;
}
.XPathBlock_fullScreen__oTV8E .XPathBlock_app-sidebar__Pq3\\+5 .XPathBlock_app-sidebar-resizer__xxmqG:hover {
  width: 4px;
  background: grey;
}
.XPathBlock_fullScreen__oTV8E #XPathBlock_CDAInitHeight__Hj-SL {
  width: 100vw !important;
  height: 92vh !important;
  transition: width 0.5s !important;
}
.XPathBlock_fullScreen__oTV8E #XPathBlock_CDA_content__MVRWU {
  width: 100% !important;
  height: 92vh !important;
  padding: 0 !important;
}
.XPathBlock_fullScreen__oTV8E .XPathBlock_footer__8pY8Z > div {
  height: 8vh !important;
}
.XPathBlock_fullScreen__oTV8E [class^=VisualizationXPathes] {
  height: 69vh !important;
}
.XPathBlock_fullScreen__oTV8E #XPathBlock_xPathesWrapper__vDGoy,
.XPathBlock_fullScreen__oTV8E #XPathBlock_CDARedactorWrapper__t5bik {
  max-width: 100%;
}
.XPathBlock_fullScreen__oTV8E #XPathBlock_CDARedactor__vW2Cn {
  height: 100vh !important;
  transition: height 1s !important;
}
.XPathBlock_fullScreen__oTV8E #XPathBlock_StructureXPathes__hiyQG {
  height: auto !important;
  transition: height 1s !important;
}
.XPathBlock_fullScreen__oTV8E #XPathBlock_CDARedactor_tabContent__N7loj,
.XPathBlock_fullScreen__oTV8E #XPathBlock_StructureXPathes_content__7ZhGL {
  height: 76vh !important;
  transition: height 1s !important;
}

.XPathBlock_ant-tree-treenode__xQZRQ {
  width: 100% !important;
}

.XPathBlock_ant-tree-node-content-wrapper__8WP9Z {
  width: 100% !important;
}

.XPathBlock_ant-tree-checkbox__L\\+1cN {
  align-self: center !important;
  margin-top: 0 !important;
}

.XPathBlock_ant-tree-checkbox__L\\+1cN + span {
  padding: 0 !important;
}

.XPathBlock_ant-tree-treenode__xQZRQ.XPathBlock_ant-tree-treenode-switcher-close__hQldo.XPathBlock_ant-tree-treenode-draggable__PKauI {
  width: 100% !important;
  max-width: 100% !important;
}

.XPathBlock_ant-tree-treenode__xQZRQ.XPathBlock_ant-tree-treenode-switcher-open__HGOvv.XPathBlock_ant-tree-treenode-draggable__PKauI {
  width: 100% !important;
  max-width: 100% !important;
}

.XPathBlock_ant-tabs-nav__hph\\+E {
  height: 4vh !important;
}

.XPathBlock_ant-tabs-tab-remove__89bK5 {
  padding: 0 !important;
}

.XPathBlock_CollapsedBlock__poWK2 {
  width: 100%;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 {
  width: 100%;
  z-index: 100;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq label {
  width: auto !important;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_xPathResponse__0A0LV {
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  padding: 8px 12px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_xPathResponse__0A0LV ul {
  margin: 0;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_xPathResponse__0A0LV ul li::marker {
  color: #00A899;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_xPathResponse__0A0LV ol {
  margin: 0;
  padding: 0 8px;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_fieldsWrapper__PxFNV {
  width: 100%;
  margin-bottom: 12px;
  display: flex;
  gap: 12px;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_fieldsWrapper__PxFNV .XPathBlock_field__f25uc {
  min-width: 50%;
  flex: 1 1;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_fieldsWrapper__PxFNV .XPathBlock_field__f25uc label {
  width: 168px;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_fieldsWrapper__PxFNV .XPathBlock_field__f25uc > div > div {
  margin: 0;
  padding: 0;
  line-height: 1.35;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_fieldsWrapper__PxFNV .XPathBlock_mandatoryPlurality__2XSse {
  margin: 0 !important;
  padding: 0 4px !important;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_fieldsWrapper__PxFNV .XPathBlock_mandatoryPlurality__2XSse > div > div {
  padding: 0 !important;
  margin: 0 !important;
  line-height: 1.2 !important;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_fieldsWrapper__PxFNV .XPathBlock_switchWraper__WNGZm {
  text-align: right;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 4px;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_fieldsWrapper__PxFNV .XPathBlock_switchWraper__WNGZm button {
  margin-right: 8px;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_fieldsWrapper__PxFNV > div {
  max-width: 50%;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_showAllSettingsWrapper__npn7L {
  height: 24px;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_XPathBlock__Y5Mo6 .XPathBlock_content__BvHTq .XPathBlock_showAllSettingsWrapper__npn7L button {
  float: right;
}
.XPathBlock_CollapsedBlock__poWK2 .XPathBlock_title__ix-o4 {
  width: 100% !important;
  margin: 0 !important;
}

.XPathBlock_statusWrapper__gRhdr .XPathBlock_status__klE06 {
  display: flex !important;
  align-items: center !important;
}
.XPathBlock_statusWrapper__gRhdr .XPathBlock_status__klE06 .XPathBlock_successDot__pGsJc,
.XPathBlock_statusWrapper__gRhdr .XPathBlock_status__klE06 .XPathBlock_plannedDot__awd2A,
.XPathBlock_statusWrapper__gRhdr .XPathBlock_status__klE06 .XPathBlock_processDot__RoXHD,
.XPathBlock_statusWrapper__gRhdr .XPathBlock_status__klE06 .XPathBlock_errorDot__UfB1G,
.XPathBlock_statusWrapper__gRhdr .XPathBlock_status__klE06 .XPathBlock_unknownDot__AMxRl {
  width: 6px !important;
  height: 6px !important;
  border-radius: 100px !important;
  margin-right: 8px !important;
}
.XPathBlock_statusWrapper__gRhdr .XPathBlock_status__klE06 .XPathBlock_unknown-dot__xOevD {
  background: #9a9898 !important;
}
.XPathBlock_statusWrapper__gRhdr .XPathBlock_status__klE06 .XPathBlock_successDot__pGsJc {
  background: #52C41A !important;
}
.XPathBlock_statusWrapper__gRhdr .XPathBlock_status__klE06 .XPathBlock_plannedDot__awd2A {
  background: #FAAD14 !important;
}
.XPathBlock_statusWrapper__gRhdr .XPathBlock_status__klE06 .XPathBlock_processDot__RoXHD {
  background: #1890FF !important;
}
.XPathBlock_statusWrapper__gRhdr .XPathBlock_status__klE06 .XPathBlock_errorDot__UfB1G {
  background: #FF4D4F !important;
}`, "",{"version":3,"sources":["webpack://./src/components/assets/styles/fonts/fonts.css","webpack://./src/components/modules/tables/components/DocumentProcessing/TreatmentCDA/XPathBlock.tsx/XPathBlock.module.scss","webpack://./src/components/assets/styles/base/base.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,4CAAA;EACA,uTAAA;EAKA,gBAAA;EACA,kBAAA;ACHJ;ACJA;EACE,wBAAA;EACA,0BAAA;ADMF;;ACWA;EACE,cAfW;ADOb;;ACWA;EACE,uBAAA;ADRF;;ACYE;EACE,0BAAA;ADTJ;;ACaA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;ADVF;;ACcA;EACE,mBAAA;ADXF;;ACcA;EACE,8BAAA;ADXF;;ACcA;EACE,6BAAA;ADXF;;ACcA;EACE,qBAAA;ADXF;;ACcA;EACE,oCAAA;EACA,8BAAA;ADXF;;ACcA;EACE,8BAAA;ADXF;;ACcA;;EAEE,4BAAA;ADXF;;ACgBE;EACE,wBAAA;EACA,2BAAA;ADbJ;;ACiBA;EACE,UAAA;ADdF;;ACiBA;EACE,WAAA;ADdF;;ACiBA;EACE,WAAA;EACA,eAAA;ADdF;;ACiBA;EACE,2BAAA;EACA,2BAAA;ADdF;;ACiBA;EACE,0BAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,8BAAA;ADdF;ACgBE;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;ADdJ;ACiBE;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,0DAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;ADfJ;ACkBE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,kEAAA;EACA,gBAAA;EACA,4BAAA;EACA,UAAA;ADhBJ;ACmBE;EACE,SAAA;ADjBJ;ACoBE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;EACA,6CAAA;EAEA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;ADnBJ;ACqBE;EAEE,sBAAA;EACA,0BAAA;EACA,kBAAA;ADpBJ;ACuBE;EACE,UAAA;EACA,gBAAA;ADrBJ;ACwBE;EACE,uBAAA;EACA,uBAAA;EACA,iCAAA;ADtBJ;ACwBE;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;ADtBJ;ACyBE;EACE,sBAAA;ADvBJ;ACyBE;EACE,uBAAA;ADvBJ;ACyBE;;EAEE,eAAA;ADvBJ;AC0BE;EACE,wBAAA;EACA,gCAAA;ADxBJ;AC2BE;EACE,uBAAA;EACA,gCAAA;ADzBJ;AC4BE;;EAEE,uBAAA;EACA,gCAAA;AD1BJ;;AC8BA;EACE,sBAAA;AD3BF;;AC8BA;EACE,sBAAA;AD3BF;;AC8BA;EACE,6BAAA;EACA,wBAAA;AD3BF;;AC8BA;EACE,qBAAA;AD3BF;;AC6BA;EACE,sBAAA;EACA,0BAAA;AD1BF;;AC4BA;EACE,sBAAA;EACA,0BAAA;ADzBF;;AC4BA;EACE,sBAAA;ADzBF;;AC4BA;EACE,qBAAA;ADzBF;;AApNA;EACE,WAAA;AAuNF;AAtNE;EACE,WAAA;EACA,YAAA;AAwNJ;AArNM;EACE,sBAAA;AAuNR;AApNM;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AAsNR;AApNQ;EACE,SAAA;AAsNV;AArNU;EACE,cChBC;ADuOb;AAnNQ;EACE,SAAA;EACA,cAAA;AAqNV;AAjNM;EACE,WAAA;EACA,mBAAA;EAEA,aAAA;EACA,SAAA;AAkNR;AAhNQ;EACE,cAAA;EACA,SAAA;AAkNV;AAhNU;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;AAkNZ;AA/MQ;EACE,SAAA;EACA,UAAA;EACA,iBAAA;AAiNV;AA9MQ;EACE,oBAAA;EACA,yBAAA;AAgNV;AA9MQ;EACE,qBAAA;EACA,oBAAA;EACA,2BAAA;AAgNV;AA7MQ;EACE,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,QAAA;AA+MV;AA7MU;EACE,iBAAA;AA+MZ;AA3MM;EACE,cAAA;AA6MR;AA1MM;EACE,YAAA;AA4MR;AA3MQ;EACE,YAAA;AA6MV;AAxME;EACE,sBAAA;EACA,oBAAA;AA0MJ;;AAtME;EACE,wBAAA;EACA,8BAAA;AAyMJ;AAvMI;;;;;EAKE,qBAAA;EACA,sBAAA;EACA,+BAAA;EACA,4BAAA;AAyMN;AAtMI;EACE,8BAAA;AAwMN;AArMI;EACE,8BAAA;AAuMN;AApMI;EACE,8BAAA;AAsMN;AAnMI;EACE,8BAAA;AAqMN;AAlMI;EACE,8BAAA;AAoMN","sourcesContent":["@font-face {\n    font-family: 'SF Pro Display';\n    src: url('SFProDisplay-Semibold.eot');\n    src: local('SF Pro Display Semibold'), local('SFProDisplay-Semibold'),\n        url('SFProDisplay-Semibold.eot?#iefix') format('embedded-opentype'),\n        url('SFProDisplay-Semibold.woff2') format('woff2'),\n        url('SFProDisplay-Semibold.woff') format('woff'),\n        url('SFProDisplay-Semibold.ttf') format('truetype');\n    font-weight: 600;\n    font-style: normal;\n}\n","@import \"../../../../../../../components/assets/styles/base/base\";\n.CollapsedBlock {\n  width: 100%;\n  .XPathBlock {\n    width: 100%;\n    z-index: 100;\n\n    .content {\n      label {\n        width: auto !important;\n      }\n\n      .xPathResponse {\n        border: 1px solid #d9d9d9;\n        border-radius: 2px;\n        padding: 8px 12px;\n        margin-bottom: 12px;\n        display: flex;\n        justify-content: space-between;\n\n        ul {\n          margin: 0;\n          li::marker {\n            color: $primeColor;\n          }\n        }\n\n        ol {\n          margin: 0;\n          padding: 0 8px;\n        }\n      }\n\n      .fieldsWrapper {\n        width: 100%;\n        margin-bottom: 12px;\n\n        display: flex;\n        gap: 12px;\n\n        .field {\n          min-width: 50%;\n          flex: 1 1;\n\n          label {\n            width: 168px;\n            white-space: nowrap;\n            overflow: hidden;\n            display: inline-block;\n            text-overflow: ellipsis;\n          }\n        }\n        .field > div > div {\n          margin: 0;\n          padding: 0;\n          line-height: 1.35;\n        }\n\n        .mandatoryPlurality {\n          margin: 0!important;\n          padding: 0 4px!important;\n        }\n        .mandatoryPlurality > div > div {\n          padding: 0!important;\n          margin: 0!important;\n          line-height: 1.2!important;\n        }\n\n        .switchWraper {\n          text-align: right;\n          display: flex;\n          align-items: flex-end;\n          justify-content: flex-end;\n          gap: 4px;\n\n          button {\n            margin-right: 8px;\n          }\n        }\n      }\n      .fieldsWrapper > div {\n        max-width: 50%;\n      }\n\n      .showAllSettingsWrapper {\n        height: 24px;\n        button {\n          float: right;\n        }\n      }\n    }\n  }\n  .title {\n    width: 100%!important;\n    margin: 0!important;\n  }\n}\n.statusWrapper {\n  .status {\n    display: flex!important;\n    align-items: center!important;\n\n    .successDot,\n    .plannedDot,\n    .processDot,\n    .errorDot,\n    .unknownDot {\n      width: 6px!important;\n      height: 6px!important;\n      border-radius: 100px!important;\n      margin-right: 8px!important;\n    }\n\n    .unknown-dot {\n      background: #9a9898!important;\n    }\n\n    .successDot {\n      background: #52C41A!important;\n    }\n\n    .plannedDot {\n      background: #FAAD14!important;\n    }\n\n    .processDot {\n      background: #1890FF!important;\n    }\n\n    .errorDot {\n      background: #FF4D4F!important;\n    }\n  }\n}\n","@import \"../mixins/mixins\";\n\n:root {\n  --appSidebarWidth: 400px;\n  xPathesWrapperWidth: 400px;\n}\n\n$primeColor: #00A899;\n$backgroundColor: #04867a;\n\nbody {\n  //font-family: Roboto;\n  //font-size: 14px;\n  //font-style: normal;\n  //font-weight: 500;\n  //line-height: 22px;\n  //font-family: \"SF Pro Display\", serif;\n  //font-weight: 500;\n  //min-height: 100%;\n}\n\n.site-form-item-icon {\n  color: $primeColor;\n}\n\n.ant-tabs-content, .ant-tabs-tabpane {\n  height: 100% !important;\n}\n\n.ant-col.ant-form-item-control.css-dev-only-do-not-override-14wewjn {\n  label {\n    display: inline !important;\n  }\n}\n\n.ant-form-item-control-input-content {\n  display: flex;\n  align-items: center !important;\n  gap: 8px;\n}\n\n\n.site-tree-search-value {\n  background: #d3fd1a;\n}\n\n.ant-tree .ant-tree-treenode {\n  align-items: center !important;\n}\n\ntextarea {\n  overflow-y: scroll !important;\n}\n\ntextarea::-webkit-scrollbar {\n  width: 4px !important;\n}\n\ntextarea::-webkit-scrollbar-thumb {\n  background-color: $backgroundColor !important;\n  border-radius: 50px !important;\n}\n\ntextarea::-webkit-scrollbar-track {\n  background: #e2e4e7 !important;\n}\n\n.ant-tree-switcher.ant-tree-switcher_close,\n.ant-tree-switcher.ant-tree-switcher_open {\n  line-height: 46px !important;\n}\n\ndiv[class*=\"TableAllProjects\"] {\n  //.ant-table-wrapper.css-dev-only-do-not-override-1x83488 {\n  .ant-table-wrapper {\n    padding: 24px !important;\n    background: #fff !important;\n  }\n}\n\n.app-sidebar {\n  width: 50%;\n}\n\n.app-sidebar .app-sidebar-content {\n  width: 100%;\n}\n\n#CDARedactorWrapper {\n  width: 100%;\n  max-width: 100%;\n}\n\n.ant-tree-treenode {\n  min-width: 400px !important;\n  max-width: 600px !important;\n}\n\n.fullScreen {\n  position: fixed !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  left: 0 !important;\n  right: 0 !important;\n  top: 0 !important;\n  bottom: 0 !important;\n  z-index: 9 !important;\n  background: #F0F2F5 !important;\n\n  .app-container {\n    min-height: 90vh;\n    padding: 1em 1em;\n    display: flex;\n    flex-direction: row;\n    height: 90vh;\n  }\n\n  .app-sidebar {\n    flex-grow: 0;\n    flex-shrink: 0;\n    min-width: 400px;\n    max-width: calc(100vw - var(--appSidebarWidth))!important;\n    display: flex;\n    flex-direction: row;\n    z-index: 2;\n  }\n\n  .app-frame {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    height: 90vh;\n    max-height: 90vh;\n    width: calc(100vw - var(--xPathesWrapperWidth) - 200px)!important;\n    min-width: 400px;\n    border-radius: 0 10px 10px 0;\n    z-index: 1;\n  }\n\n  .app-sidebar .app-sidebar-content {\n    flex: 1;\n  }\n\n  .app-sidebar-resizer {\n    position: relative;\n    height: 84vh;\n    width: 3px;\n    top: 4vh;\n    border-radius: 10px;\n    background: #c1c3c5b4;\n\n    flex-grow: 0;\n    flex-shrink: 0;\n    justify-self: flex-end;\n    cursor: col-resize;\n    resize: horizontal;\n  }\n  .ant-tree-treenode.ant-tree-treenode-switcher-open.ant-tree-treenode-draggable{\n    //width: calc(100vw - var(--xPathesWrapperWidth))!important;\n    width: 100%!important;\n    max-width: 100%!important;\n    position: relative;\n  }\n\n  .app-sidebar .app-sidebar-resizer:hover {\n    width: 4px;\n    background: grey;\n  }\n\n  #CDAInitHeight {\n    width: 100vw !important;\n    height: 92vh !important;\n    transition: width 0.5s !important;\n  }\n  #CDA_content {\n    width: 100% !important;\n    height: 92vh !important;\n    padding: 0!important;\n  }\n\n  .footer > div {\n    height: 8vh!important;\n  }\n  [class^=VisualizationXPathes] {\n    height: 69vh!important;\n  }\n  #xPathesWrapper,\n  #CDARedactorWrapper {\n    max-width: 100%;\n  }\n\n  #CDARedactor {\n    height: 100vh !important;\n    transition: height 1s !important;\n  }\n\n  #StructureXPathes {\n    height: auto !important;\n    transition: height 1s !important;\n  }\n\n  #CDARedactor_tabContent,\n  #StructureXPathes_content {\n    height: 76vh !important;\n    transition: height 1s !important;\n  }\n}\n\n.ant-tree-treenode {\n  width: 100% !important;\n}\n\n.ant-tree-node-content-wrapper {\n  width: 100% !important;\n}\n\n.ant-tree-checkbox {\n  align-self: center !important;\n  margin-top: 0 !important;\n}\n\n.ant-tree-checkbox + span {\n  padding: 0 !important;\n}\n.ant-tree-treenode.ant-tree-treenode-switcher-close.ant-tree-treenode-draggable {\n  width: 100%!important;\n  max-width: 100%!important;\n}\n.ant-tree-treenode.ant-tree-treenode-switcher-open.ant-tree-treenode-draggable {\n  width: 100%!important;\n  max-width: 100%!important;\n}\n\n.ant-tabs-nav {\n  height: 4vh!important;\n}\n\n.ant-tabs-tab-remove {\n  padding: 0!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"site-form-item-icon": `XPathBlock_site-form-item-icon__7aRnV`,
	"ant-tabs-content": `XPathBlock_ant-tabs-content__u9wAw`,
	"ant-tabs-tabpane": `XPathBlock_ant-tabs-tabpane__h5jM2`,
	"ant-col": `XPathBlock_ant-col__uQYYe`,
	"ant-form-item-control": `XPathBlock_ant-form-item-control__FpE8Z`,
	"css-dev-only-do-not-override-14wewjn": `XPathBlock_css-dev-only-do-not-override-14wewjn__G0Qh3`,
	"ant-form-item-control-input-content": `XPathBlock_ant-form-item-control-input-content__KFMph`,
	"site-tree-search-value": `XPathBlock_site-tree-search-value__iPh3f`,
	"ant-tree": `XPathBlock_ant-tree__ubqlb`,
	"ant-tree-treenode": `XPathBlock_ant-tree-treenode__xQZRQ`,
	"ant-tree-switcher": `XPathBlock_ant-tree-switcher__1557e`,
	"ant-tree-switcher_close": `XPathBlock_ant-tree-switcher_close__Gq+La`,
	"ant-tree-switcher_open": `XPathBlock_ant-tree-switcher_open__hpHdJ`,
	"ant-table-wrapper": `XPathBlock_ant-table-wrapper__WwCvq`,
	"app-sidebar": `XPathBlock_app-sidebar__Pq3+5`,
	"app-sidebar-content": `XPathBlock_app-sidebar-content__x0sK+`,
	"CDARedactorWrapper": `XPathBlock_CDARedactorWrapper__t5bik`,
	"fullScreen": `XPathBlock_fullScreen__oTV8E`,
	"app-container": `XPathBlock_app-container__bjqQl`,
	"app-frame": `XPathBlock_app-frame__4ruN3`,
	"app-sidebar-resizer": `XPathBlock_app-sidebar-resizer__xxmqG`,
	"ant-tree-treenode-switcher-open": `XPathBlock_ant-tree-treenode-switcher-open__HGOvv`,
	"ant-tree-treenode-draggable": `XPathBlock_ant-tree-treenode-draggable__PKauI`,
	"CDAInitHeight": `XPathBlock_CDAInitHeight__Hj-SL`,
	"CDA_content": `XPathBlock_CDA_content__MVRWU`,
	"footer": `XPathBlock_footer__8pY8Z`,
	"xPathesWrapper": `XPathBlock_xPathesWrapper__vDGoy`,
	"CDARedactor": `XPathBlock_CDARedactor__vW2Cn`,
	"StructureXPathes": `XPathBlock_StructureXPathes__hiyQG`,
	"CDARedactor_tabContent": `XPathBlock_CDARedactor_tabContent__N7loj`,
	"StructureXPathes_content": `XPathBlock_StructureXPathes_content__7ZhGL`,
	"ant-tree-node-content-wrapper": `XPathBlock_ant-tree-node-content-wrapper__8WP9Z`,
	"ant-tree-checkbox": `XPathBlock_ant-tree-checkbox__L+1cN`,
	"ant-tree-treenode-switcher-close": `XPathBlock_ant-tree-treenode-switcher-close__hQldo`,
	"ant-tabs-nav": `XPathBlock_ant-tabs-nav__hph+E`,
	"ant-tabs-tab-remove": `XPathBlock_ant-tabs-tab-remove__89bK5`,
	"CollapsedBlock": `XPathBlock_CollapsedBlock__poWK2`,
	"XPathBlock": `XPathBlock_XPathBlock__Y5Mo6`,
	"content": `XPathBlock_content__BvHTq`,
	"xPathResponse": `XPathBlock_xPathResponse__0A0LV`,
	"fieldsWrapper": `XPathBlock_fieldsWrapper__PxFNV`,
	"field": `XPathBlock_field__f25uc`,
	"mandatoryPlurality": `XPathBlock_mandatoryPlurality__2XSse`,
	"switchWraper": `XPathBlock_switchWraper__WNGZm`,
	"showAllSettingsWrapper": `XPathBlock_showAllSettingsWrapper__npn7L`,
	"title": `XPathBlock_title__ix-o4`,
	"statusWrapper": `XPathBlock_statusWrapper__gRhdr`,
	"status": `XPathBlock_status__klE06`,
	"successDot": `XPathBlock_successDot__pGsJc`,
	"plannedDot": `XPathBlock_plannedDot__awd2A`,
	"processDot": `XPathBlock_processDot__RoXHD`,
	"errorDot": `XPathBlock_errorDot__UfB1G`,
	"unknownDot": `XPathBlock_unknownDot__AMxRl`,
	"unknown-dot": `XPathBlock_unknown-dot__xOevD`
};
export default ___CSS_LOADER_EXPORT___;
